(function () {
  /**
   * iOS Safari often ignores the HTML autoplay attribute; muted + playsInline + play() is required.
   */
  function wireMutedAutoplay(video) {
    if (!(video instanceof HTMLVideoElement) || video.dataset.autoplayWired === 'true') return;
    if (!video.autoplay && !video.hasAttribute('autoplay')) return;

    video.dataset.autoplayWired = 'true';
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.controls = false;

    var ensurePlaying = function () {
      if (video.paused) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }
    };

    ensurePlaying();
    video.addEventListener('loadeddata', ensurePlaying);
    video.addEventListener('canplay', ensurePlaying);
    video.addEventListener('pause', ensurePlaying);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) ensurePlaying();
    });
  }

  function initEditorialVideo(wrap) {
    if (wrap.dataset.allerasVideoInit) return;

    wrap.querySelectorAll('video.alleras-col-grid__video-autoplay').forEach(wireMutedAutoplay);

    var media = wrap.querySelector('deferred-media.alleras-col-grid__video-el');
    var blur = wrap.querySelector('.alleras-col-grid__video-blur');
    if (!media || !blur) {
      if (wrap.querySelector('video.alleras-col-grid__video-autoplay')) {
        wrap.dataset.allerasVideoInit = 'true';
      }
      return;
    }

    wrap.dataset.allerasVideoInit = 'true';

    function syncBlur() {
      var video = media.querySelector('video');
      var blurVideo = blur.querySelector('video');
      if (media.hasAttribute('data-media-loaded') && video) {
        if (!blurVideo) {
          blurVideo = video.cloneNode(true);
          blurVideo.removeAttribute('id');
          blurVideo.setAttribute('tabindex', '-1');
          blurVideo.setAttribute('aria-hidden', 'true');
          blurVideo.muted = true;
          blurVideo.defaultMuted = true;
          blur.appendChild(blurVideo);
        }
        if (!video.paused) {
          if (blurVideo.paused) blurVideo.play().catch(function () {});
        } else {
          blurVideo.pause();
        }
      } else if (blurVideo) {
        blurVideo.remove();
      }
    }

    function syncBlurTime() {
      var video = media.querySelector('video');
      var blurVideo = blur.querySelector('video');
      if (!video || !blurVideo || video.paused) return;
      if (Math.abs(blurVideo.currentTime - video.currentTime) > 0.25) {
        blurVideo.currentTime = video.currentTime;
      }
    }

    media.addEventListener('play', syncBlur, true);
    media.addEventListener('pause', syncBlur, true);
    media.addEventListener('timeupdate', syncBlurTime, true);
    new MutationObserver(syncBlur).observe(media, {
      attributes: true,
      attributeFilter: ['data-media-loaded']
    });
  }

  function initCollection(root) {
    if (!root || root.dataset.allerasColInit) return;
    root.dataset.allerasColInit = 'true';

    var form = root.querySelector('form');
    var mobileWrap = root.querySelector('[data-alleras-filters-mobile]');
    var sidebar = root.querySelector('[data-alleras-filters]');
    var mobileToggle = root.querySelector('[data-alleras-mobile-filters]');

    root.querySelectorAll('.alleras-col-grid__video').forEach(initEditorialVideo);

    function setFiltersOpen(open) {
      if (mobileWrap) mobileWrap.classList.toggle('is-open', open);
      if (sidebar) sidebar.classList.toggle('is-open', open);
      if (mobileToggle) mobileToggle.setAttribute('aria-expanded', String(open));
      if (open) {
        if (typeof window.allerasLockPageScroll === 'function') {
          window.allerasLockPageScroll();
        } else {
          document.documentElement.style.overflow = 'hidden';
        }
      } else if (typeof window.allerasUnlockPageScroll === 'function') {
        window.allerasUnlockPageScroll();
      } else if (
        !document.querySelector('[data-alleras-drawer].is-open') &&
        !document.getElementById('size-guide')?.classList.contains('is-open')
      ) {
        document.documentElement.style.overflow = '';
      }
    }

    function closeFilters() {
      setFiltersOpen(false);
    }

    if (mobileToggle && sidebar) {
      mobileToggle.addEventListener('click', function () {
        setFiltersOpen(!sidebar.classList.contains('is-open'));
      });

      root.querySelectorAll('[data-alleras-filters-close]').forEach(function (el) {
        el.addEventListener('click', closeFilters);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && sidebar.classList.contains('is-open')) {
          closeFilters();
        }
      });
    }

    if (form) {
      form.querySelectorAll('[data-alleras-auto-submit]').forEach(function (el) {
        el.addEventListener('change', function () {
          form.submit();
        });
      });

      var priceReset = form.querySelector('[data-alleras-reset-price]');
      if (priceReset) {
        priceReset.addEventListener('click', function () {
          form.querySelectorAll('.alleras-col-price input').forEach(function (input) {
            input.value = '';
          });
          form.submit();
        });
      }
    }
  }

  function initLookbookMode() {
    if (!document.documentElement.classList.contains('alleras-collection--lookbook')) return;

    document.querySelectorAll('.alleras-lookbook__pagination a').forEach(function (link) {
      var url = new URL(link.href, window.location.origin);
      url.searchParams.set('lookbook', '1');
      link.href = url.toString();
    });
  }

  document.querySelectorAll('.alleras-col').forEach(initCollection);
  initLookbookMode();
})();
